import { ColumnsType } from 'antd/es/table'
import renderDatetime from '../../../../helpers/tables/render-datetime'
import { FormsTableRow } from '../types/forms-table-row'
import FormOrderOrderStatusCell from '../components/form-order-order-status-cell/form-order-order-status-cell'
import InStockCheckbox from '../components/in-stock-checkbox/in-stock-checkbox'
import { Space } from 'antd'
import { DefectCheckbox } from '../components/defect-checkbox/defect-checkbox'
import { FailureReason } from '../../../../types/api/form'
import { toCssHex } from '../../../../helpers/color/to-css-hex'

export const orderLevelCell = (record: FormsTableRow) => ({
    style: { verticalAlign: 'top' as const },
    rowSpan: record.rowSpan,
})

type GetColumnsOptions = {
    onRefetch: () => void
    disableStockEdit?: boolean
}

export const getColumns = ({
    onRefetch,
    disableStockEdit = false,
}: GetColumnsOptions): ColumnsType<FormsTableRow> => [
    {
        title: 'Номер заказа',
        dataIndex: 'orderId',
        width: 90,
        onCell: orderLevelCell,
    },
    {
        title: 'Формы',
        dataIndex: 'formsCount',
        width: 70,
        onCell: orderLevelCell,
    },
    {
        title: 'Статус',
        dataIndex: 'orderStatus',
        width: 130,
        onCell: orderLevelCell,
        render: orderStatus => <FormOrderOrderStatusCell orderStatus={orderStatus} />,
    },
    {
        title: 'Дата создания',
        dataIndex: 'orderCreatedAt',
        width: 150,
        onCell: orderLevelCell,
        render: (v?: string) => (v ? renderDatetime(v) : undefined),
    },
    {
        title: 'Дата поставки',
        dataIndex: 'orderEstimatedDate',
        width: 150,
        onCell: orderLevelCell,
        render: (v?: string) => (v ? renderDatetime(v) : undefined),
    },
    {
        title: 'Состав заказа',
        children: [
            {
                title: 'Набор форм',
                dataIndex: ['form_set', 'id'],
                width: 150,
            },
            {
                title: 'Номер формы',
                dataIndex: 'num',
                width: 100,
            },
            {
                title: 'Цвет',
                dataIndex: 'color',
                width: 100,
                render: (v?: string) => {
                    const color = toCssHex(v)
                    if (!color) return null

                    return (
                        <Space>
                            <div
                                style={{
                                    width: '22px',
                                    height: '22px',
                                    background: color,
                                    borderRadius: '4px',
                                }}
                            />
                            <span>{color}</span>
                        </Space>
                    )
                },
            },
            {
                title: 'Название',
                dataIndex: 'colorName',
                width: 150,
            },
            {
                title: 'В наличии',
                dataIndex: 'inStock',
                width: 100,
                render: (_v, record) => (
                    <InStockCheckbox
                        formDocumentId={record.documentId}
                        checked={record.inStock === true}
                        disabled={
                            disableStockEdit ||
                            record.orderStatus === 'Завершен' ||
                            record.failureReason === FailureReason.ManufacturingDefect
                        }
                        onSuccess={onRefetch}
                    />
                ),
            },
            {
                title: 'Брак',
                dataIndex: 'defect',
                width: 180,
                render: (_v, record) => {
                    if (record.orderStatus === 'Завершен') {
                        if (!record.failureReason && !record.dateOfFailure) return null

                        return (
                            <>
                                {record.failureReason}
                                {record.failureReason && record.dateOfFailure ? <br /> : null}
                                {record.dateOfFailure
                                    ? renderDatetime(record.dateOfFailure)
                                    : null}
                            </>
                        )
                    }

                    return <DefectCheckbox row={record} onDefectRegistered={onRefetch} />
                },
            },
        ],
    },
]
